<cmv-modal-base [isModalOpen]="isModalVisible" positionContent="center">
	<section class="confirm-dialog">
		<h1 class="confirm-dialog__title">{{ title }}</h1>
		<p class="confirm-dialog__message">{{ message }}</p>
		<section class="confirm-dialog__actions">
			<button cmvBtn="text" (click)="onCloseModal()">OK</button>
		</section>
	</section>
</cmv-modal-base>
 
